import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronUp } from "lucide-react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.4 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          data-testid="back-to-top"
          onClick={toTop}
          initial={{ opacity: 0, y: 20, scale: 0.8 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.8 }}
          whileHover={{ scale: 1.08 }}
          whileTap={{ scale: 0.92 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          aria-label="Back to top"
          className="slash-host group fixed bottom-6 left-6 z-40 grid h-12 w-12 place-items-center rounded-full border border-[#d91616]/60 bg-black/60 text-[#d91616] backdrop-blur-md transition-colors hover:bg-[#d91616] hover:text-white"
        >
          <ChevronUp size={20} className="transition-transform group-hover:-translate-y-0.5" />
          <span className="absolute inset-0 rounded-full shadow-[0_0_30px_-6px_rgba(217,22,22,0.7)] opacity-0 transition-opacity group-hover:opacity-100" />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
